// LabelSeries recreates these sprites from text/settings. Serializing them makes
// JsonParser build a second, detached EditableLabel (and HTML editor) on reload.
// Clean old saved records as well, without changing drawing coordinates/styles.
const cleanTextDrawings = data => {
  const clean = drawing => {
    if (!drawing || !['Label', 'Callout'].includes(drawing.__tool)
      || !Array.isArray(drawing.__drawing)) return drawing;
    return {
      ...drawing,
      __drawing: drawing.__drawing.map(row => {
        if (!row || typeof row !== 'object') return row;
        const savedRow = { ...row };
        delete savedRow.label;
        delete savedRow.sprite;
        delete savedRow.background;
        return savedRow;
      }),
    };
  };
  return Array.isArray(data) ? data.map(clean) : clean(data);
};

export function configureDrawingPersistence(control) {
  const serialize = control.serializeDrawings;
  const restore = control.unserializeDrawings;
  control.serializeDrawings = function (output = 'string', indent) {
    const data = cleanTextDrawings(serialize.call(this, 'object'));
    return output === 'object' ? data : JSON.stringify(data, undefined, indent);
  };
  control.unserializeDrawings = function (data) {
    return restore.call(this, cleanTextDrawings(typeof data === 'string' ? JSON.parse(data) : data));
  };
}
